import { useMemo } from "react"
import { className } from "../helpers/className"

const useClassName = (...classList) => {
  return useMemo(() => className(...classList), [classList])
}

export default useClassName
